export enum TableCellType {
    Text,
    Image,
}
